(function(){
    "use strict";
    
    angular
        .module("app")
        .component("addUser", { // add-user
            bindings: {
                onUserAdded: "&"
            },
            templateUrl: "src/app/account/childAccounts/addUser/addUser.html",
            controller: controller
        });

    function controller($http, session, toast, EMAIL_FORMAT) {
        const $ctrl = this;
        $ctrl.session = session;
        $ctrl.emailFormat = EMAIL_FORMAT;
        $ctrl.email = "";
        $ctrl.user = {
            user_id: null,
            email: null,
            first_name: null,
            last_name: null
        };
        $ctrl.roles = {
            admin: true,
            reporting: true,
            purchasing: true
        };

        $ctrl.ui = {
            showStep1: () => $ctrl.user.email == null,
            showStep2: () => $ctrl.user.email != null,
            canContinue: () => $ctrl.email,
            canAddUser: () => $ctrl.user.first_name && $ctrl.user.last_name
        };

        $ctrl.continueClicked = () => {
            const request = { email: $ctrl.email };
            $http
                .post("/api/users/for-email", request)
                .then(result => {
                    const user = result.data;
                    $ctrl.user.email = $ctrl.email;
                    if (user) {
                        $ctrl.user.user_id = user.user_id;
                        $ctrl.user.first_name = user.first_name;
                        $ctrl.user.last_name = user.last_name;
                    }
                })
                .catch(toast.errorHandler);
        };

        $ctrl.cancelClicked = clear;

        $ctrl.addUserClicked = () => {
            const request = {
                customer_id: $ctrl.session.customer.customer_id,
                email: $ctrl.email,
                first_name: $ctrl.user.first_name,
                last_name: $ctrl.user.last_name,
                is_admin_role: $ctrl.roles.admin,
                is_reporting_role: $ctrl.roles.reporting,
                is_purchasing_role: $ctrl.roles.purchasing
            };
            $http
                .post("/api/users", request)
                .then(result => {
                    $ctrl.onUserAdded({ user_id: result.data });
                    clear();
                    toast.success("Add User", `${newUser.first_name} ${newUser.last_name} added.`);
                })
                .catch(toast.errorHandler);
        };

        function clear() {
            $ctrl.email = "";
            $ctrl.user.email = null;
            $ctrl.user.user_id = null;
            $ctrl.user.first_name = null;
            $ctrl.user.last_name = null;
        }
    }
    controller.$inject = ["$http", "sessionService", "stToastFactory", "EMAIL_FORMAT"];
    
})()